import { FC, useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import AttivaCard from "../../../components/card/AttivaCard";
import { Loader } from "../../../components/loader/SpinnerLogo";
import useFetch from "../../../hooks/useFetch";
import useHandleErrors from "../../../hooks/useHandleErrors";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import { InspectorCredentialsService } from "../../../services/product/inspectorCredentialsService";
import { InspectorCredentialsRow } from "../../../type/entities/inspector-credentials-type";
import InspectorCredentialsForm from "../InspectorCredentialsForm";

const InspectorCredentialsEdit: FC = () => {

    const { id = "" } = useParams<{ id: string }>();
    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const service = new InspectorCredentialsService();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [data, loading] = useFetch(useCallback(async () => {
        const response = await service.getById(id as string);
        return response.getResponseData();
    }, [id]));

    const row = data as InspectorCredentialsRow | null | undefined;

    const pageHeader = {
        title: `Editar credencial inspector`,
        breadcrumb: [
            { name: 'Productos', href: menuRoutes.products.path },
            { name: 'Credenciales inspector AF', href: menuRoutes.products.path + menuRoutes.products.inspectorCredentials },
            { name: 'Editar' },
        ],
    };

    const handleSubmit = async (values: any) => {
        setIsLoading(true);
        try {
            const response = (await service.edit({
                inspectorCredentialsId: values.inspectorCredentialsId || id,
                productId: values.productId,
                organisingCorporationId: values.organisingCorporationId,
                platformCif: values.platformCif || null,
                platformBusinessName: values.platformBusinessName || null,
                platformUrl: values.platformUrl || null,
                inspectorUser: values.inspectorUser || null,
                inspectorPassword: values.inspectorPassword || null,
            })).getResponseData();
            if (response.success) {
                navigate(menuRoutes.products.path + menuRoutes.products.inspectorCredentials);
                toast.success("Credencial actualizada correctamente");
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error("Error al actualizar la credencial");
        } finally {
            setIsLoading(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title="Datos">
                {row && <InspectorCredentialsForm data={row} submit={handleSubmit} isLoading={isLoading} />}
            </AttivaCard>
        </>
    );
}

export default InspectorCredentialsEdit;
